var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shopOther"}},[_c('searchLR'),_vm._v(" "),_c('div',{staticClass:"bg-f6"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }